export default __webpack_public_path__ + "static/media/project_icon.43797db9.svg";